import { panelConfigFor } from './panelConfig';
import MetricCard from './components/MetricCard';
import TimeSeriesChart from './components/TimeSeriesChart';
import PlatformTable from './components/PlatformTable';

/**
 * Panel lead-gen: scorecards (leads/calificados/CPL/inversión), leads por
 * fuente + CPL diario y la tabla por plataforma. Config-driven vía panelConfig.
 */
export default function LeadGenPanel({ data }) {
  const { summary = {}, daily = [], platforms = [] } = data;
  const config = panelConfigFor('lead_gen');

  const chartData = daily.map((row) => ({
    ...row,
    cpl: row.spend != null && row.leads ? row.spend / row.leads : null,
  }));

  const visibleMetrics = config.metrics.filter(
    (m) => summary[m.key] !== null && summary[m.key] !== undefined
  );
  const visibleCharts = config.charts.filter((chart) =>
    chart.series.some((s) => chartData.some((row) => row[s.dataKey] != null))
  );

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        {visibleMetrics.map((m) => (
          <MetricCard key={m.key} label={m.label} value={summary[m.key]} format={m.format} />
        ))}
      </div>

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        {visibleCharts.map((chart) => (
          <TimeSeriesChart key={chart.key} title={chart.title} data={chartData} series={chart.series} />
        ))}
      </div>

      {platforms.length > 0 && <PlatformTable platforms={platforms} />}

      {daily.length === 0 && (
        <p className="py-8 text-center text-sm text-gray-500">
          Sin datos para el rango seleccionado.
        </p>
      )}
    </div>
  );
}
